'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { AppProgressProvider as ProgressProvider } from '@bprogress/next';

export function Provider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  //Send page view event to Google Analytics
  useEffect(() => {
    if (!pathname) return;

    const url = pathname + (searchParams?.toString() ? `?${searchParams}` : '');
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'page_view',
      page_path: url,
      page_title: document.title,
    });
  }, [pathname, searchParams]);

  return (
    <ProgressProvider
      height="2px"
      color="#044e9b"
      options={{ showSpinner: false }}>
      {children}
    </ProgressProvider>
  );
}
